import { createContext, useContext } from 'react';

interface AccessPermissionContextType {
  modules?: Module[];
  roleIndexes?: string[];
  roleSettings: (forceUpdate?: boolean) => void;
}

export const AccessPermissionContext =
  createContext<AccessPermissionContextType | null>(null);

export const useAccessPermission = (): AccessPermissionContextType => {
  const context = useContext(AccessPermissionContext);
  if (!context) {
    throw new Error(
      'useAccessPermission must be used within a AccessPermissionProvider'
    );
  }
  return context;
};
